import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'

const whiteList = ['/login', '/purchase/*'];

router.beforeEach(({ path, matched }, from, next) => {
  NProgress.start();
  const { token } = store.getters;
  if(token){
    if(path === '/login'){
      next('/');
    }else{
      next();
    }
  }else{
    let regex = matched && matched[0] && matched[0].regex
    if(regex && whiteList.find(
      item => regex.test(item)
    )){
      next();
    } else {
      next(`/login?redirect=${path}`)
    }
  }
})

router.afterEach(() => NProgress.done())



// WEBPACK FOOTER //
// ./src/permission.js